export const mapProductosToCoberturas = (productos) => {
    let prodCoberturas = []
    productos.map(producto => (
        producto.coberturas.map(cobertura => (
            prodCoberturas.push({
                codigoProducto        : producto.codigoProducto,
                codigoVersionProducto : producto.codigoVersionProducto,
                codigoCobertura       : cobertura.codigoCobertura,
                monto                 : cobertura.monto
            })
        ))
    ))
    return prodCoberturas
}

export const mapProductosToCodigosCoberturas = (productos) => {
    let idsCoberturas = []
    productos.map(producto => (
        producto.coberturas.map(cobertura => (
            idsCoberturas.push(cobertura.codigoCobertura)
        ))
    ))
    return [...new Set(idsCoberturas)].toString()
}

export const mapProductosToCodigoProductos = (productos) => {
    return (productos !== undefined
        ? productos.map((item) => {
            return item.codigoProducto;
        })?.toString()
        : null)
}

export const mapProductosToNombreProductos = (productos) => {
    const finalParams = [];
    if (productos !== undefined) {
        productos.forEach((item) => {
            finalParams.push({
                codProducto: item.codigoProducto,
                nombProducto: item.descripcion
            });
        })
    }
    return finalParams
}